var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAdmin)?_c('read-only-zone-observation'):_c('main',{staticClass:"flex flex-col w-full p-4 max-h-main min-h-main max-w-5xl"},[_c('zone-observation-form',{attrs:{"observationId":_vm.$route.params.observationId},on:{"openPhoto":_vm.openPhoto,"deleted":_vm.onDeleted,"resolved":_vm.onResolvedOrReopen,"reopen":_vm.onResolvedOrReopen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }